// extracted by mini-css-extract-plugin
module.exports = {"switch":"Switch_switch__P7j_a","input":"Switch_input__gE1dX","slider":"Switch_slider__Na4Sr"};